import type { Uom } from "features/uom/hooks/useUom";
import { UnitType } from "features/uom/spec";
import { convertAndFormat } from "features/uom/utils";

/** An object-to-object distance as its labels show it, in the user's units. */
export function formatObjectMeasureDistance(uom: Uom, meters: number) {
    return convertAndFormat(uom, meters, UnitType.length, { decimals: 3 });
}

/**
 * Whether a distance would read as zero on its label. Decided on the formatted text, since that is
 * where the rounding happens - feet and inches round to the nearest 1/16" rather than to a number of
 * decimals. Negative values are compared by size, so a tiny one doesn't get through as "-0".
 */
export function readsAsZero(uom: Uom, meters: number) {
    return formatObjectMeasureDistance(uom, Math.abs(meters)) === formatObjectMeasureDistance(uom, 0);
}
